import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
/**
 * Convert a js date to the format MMM YYYY.
 * E.g. converts '2022-04-15' to 'Apr 2020'
 * @param date
 * @returns MMM YYYY
 */
export function convertUTCDateToShortForm(date) {
  return "".concat(date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC'
  }), " ").concat(date.getUTCFullYear());
}

/**
 * Converts ISO8601 YYYY-MM-DD string to instance of Date at midnight UTC
 *
 * @param yearMonthDay For example, "2023-05-19"
 */
export function parseYearMonthDate(yearMonthDay) {
  return new Date(yearMonthDay + 'T00:00:00.000Z');
}